import type {
  ServiceAccountApiKey,
  ServicePortalError,
} from "../../services/serviceAccountsApi"

export const DEFAULT_SERVICE_ACCOUNT_API_KEY_EXPIRATION_YEARS = 1

export function formatDateTime(value: string | null): string {
  if (!value) {
    return "No expiration"
  }

  const parsedDate = new Date(value)

  if (Number.isNaN(parsedDate.getTime())) {
    return value
  }

  return parsedDate.toLocaleString()
}

export function getApiKeyStatus(apiKey: ServiceAccountApiKey): {
  color: "default" | "success" | "warning"
  label: string
} {
  if (!apiKey.key_id) {
    return { color: "default", label: "Inactive" }
  }

  if (
    apiKey.is_expired ||
    (apiKey.expires_at && new Date(apiKey.expires_at).getTime() <= Date.now())
  ) {
    return { color: "warning", label: "Expired" }
  }

  return { color: "success", label: "Active" }
}

export function getDefaultServiceAccountApiKeyExpiration(): string {
  const expirationDate = new Date()
  expirationDate.setFullYear(
    expirationDate.getFullYear() +
      DEFAULT_SERVICE_ACCOUNT_API_KEY_EXPIRATION_YEARS
  )

  return expirationDate.toISOString()
}

export function getErrorMessage(error: unknown): string | null {
  if (!error || typeof error !== "object") {
    return null
  }

  if ("data" in error && error.data && typeof error.data === "object") {
    const data = error.data as ServicePortalError
    if (typeof data.error === "string" && data.error.trim() !== "") {
      return data.error
    }
  }

  if ("message" in error && typeof error.message === "string") {
    return error.message
  }

  return null
}

export function getCreateApiKeyMutationCacheKey(
  serviceAccountId: string
): string {
  return `create-api-key:${serviceAccountId}`
}

export function getDeleteApiKeyMutationCacheKey(
  serviceAccountId: string
): string {
  return `delete-api-key:${serviceAccountId}`
}
